import { render, staticRenderFns } from "./EvaluationTrainingHotFilePage.vue?vue&type=template&id=0195a488&"
import script from "./EvaluationTrainingHotFilePage.vue?vue&type=script&lang=js&"
export * from "./EvaluationTrainingHotFilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports